<template>
  <div>
    <div class='background-header'>
      <h2 class='header'>{{ $t('Articles') }}</h2>
      <!-- <p class='page-subtitle'>
        Explore insights on personality type compatibility,
        meaningful relationships, and psychology-based dating.
      </p> -->
    </div>
    <div class='articles-container'>
      <div class='articles-grid'>
        <div v-for='article in articles' :key='article.id' class='article-card'>
          <img :src='article.image' :alt='article.title' class='article-image' />
          <div class='article-content'>
            <h2 class='article-title'>{{ article.title }}</h2>
            <p class='article-excerpt'>{{ article.excerpt }}</p>
            <router-link :to="article.link" class='article-link'>Read more</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const articles = [
  {
    id: 1,
    title: 'Understanding Compatibility: Why Some People Just Click (and Others Don’t)',
    excerpt:
      'Discover why some people just click while others don’t. Learn how socionics explains relationship compatibility through cognitive and emotional connection.',
    image: '/articles/compatibility.jpg',
    link: '/en/articles/socionics-compatibility',
  },
  {
    id: 2,
    title: 'Socionics vs MBTI: Which System Predicts Compatibility Better?',
    excerpt:
      'We compare MBTI and Socionics to see which one truly helps you understand your ideal partner.',
    image: '/articles/dating.jpg',
    link: '/en/articles/socionics-vs-mbti',
  },
  {
    id: 3,
    title: 'Why Opposites Attract (But Don’t Always Last): A Socionics perspective',
    excerpt:
      'Meetch focuses on real compatibility, not just swipes — learn how our approach is changing modern dating.',
    image: '/articles/dating-app.jpg',
    link: '/en/articles/opposites-attract',
  },
];
</script>

<style lang='scss' scoped>
@use '@/styles/breakpoints' as *;
@use '@/styles/variables' as *;
// @use '@/styles/index' as *;

.articles-container {
  max-width: 1100px;
  margin: 0 auto;
  margin-top: 10em;;
  padding: 40px 20px;

  @include breakpoint(xlarge) {
    margin-top: 300px;
  }
}

.page-subtitle {
  text-align: center;
  color: #666;
  margin-bottom: 40px;
  font-size: 1.1rem;
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
}

.article-card {
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;
}

.article-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.article-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.article-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.article-title {
  font-size: 1.25rem;
  margin-bottom: 10px;
}

.article-excerpt {
  flex-grow: 1;
  color: $myTypeMediumGray;
  margin-bottom: 15px;
}

.article-link {
  color: $myTypeRed;
  font-weight: 500;
  text-decoration: none;
}
</style>
